/* =========================
   STYLES
   ========================= */
export const pageContainer = {
  maxWidth: '1400px',
  margin: '0 auto',
  padding: '20px',
  width: '100%',
  overflowX: 'auto', // Allow horizontal scrolling
  overflowY: 'visible',
};

export const headerSection = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '30px',
  width: '100%',
};

export const pageTitle = {
  margin: 0,
  fontSize: '28px',
  color: '#1f2937',
  flexShrink: 0,
};

export const scanStatusBadge = (mode) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 20px',
  background: mode === 'ITEM' ? '#dbeafe' : '#fef3c7',
  borderRadius: '8px',
  border: `2px solid ${mode === 'ITEM' ? '#3b82f6' : '#f59e0b'}`,
});

export const statusDot = {
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  background: '#22c55e',
  animation: 'pulse 2s infinite',
};

export const statusText = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#374151',
};

export const skipButton = {
  padding: '6px 14px',
  background: '#ef4444',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  fontSize: '13px',
  fontWeight: '500',
  cursor: 'pointer',
};

export const saveButton = {
  padding: '12px 24px',
  background: '#3b82f6',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'background 0.2s',
  width: '150px'
};

export const card = {
  background: 'white',
  borderRadius: '10px',
  padding: '24px',
  marginBottom: '20px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  border: '1px solid #e5e7eb',
  overflow: 'hidden',
};

export const cardTitle = {
  margin: '0 0 20px 0',
  fontSize: '18px',
  fontWeight: '600',
  color: '#1f2937',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const formGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '20px',
};

export const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontSize: '13px',
  fontWeight: '600',
  color: '#374151',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
  boxSizing: 'border-box',
  transition: 'all 0.2s',
};

export const inputStyleFocus = {
  outline: 'none',
  borderColor: '#3b82f6',
  boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
};

export const textareaStyle = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
  fontFamily: 'inherit',
  resize: 'vertical',
  boxSizing: 'border-box',
  transition: 'all 0.2s',
  minHeight: '80px',
  lineHeight: '1.5',
};

export const textareaStyleFocus = {
  outline: 'none',
  borderColor: '#3b82f6',
  boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
};

export const fieldHint = {
  fontSize: '11px',
  color: '#6b7280',
  marginTop: '4px',
  fontStyle: 'italic',
};


export const addButton = {
  padding: '10px 18px',
  background: '#10b981',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: '500',
  cursor: 'pointer',
  width: '150px',
};

export const tableContainer = {
  overflowX: 'auto',
};

export const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

export const thStyle = {
  background: '#f9fafb',
  padding: '14px 12px',
  textAlign: 'left',
  fontSize: '13px',
  fontWeight: '600',
  color: '#6b7280',
  borderBottom: '2px solid #e5e7eb',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
};

export const tdStyle = {
  padding: '14px 12px',
  fontSize: '14px',
  color: '#374151',
};

export const selectStyle = {
  width: '100%',
  padding: '8px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
};

export const qtyInputStyle = {
  width: '70px',
  padding: '8px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
  textAlign: 'center',
};

export const qtyBadge = {
  display: 'inline-block',
  padding: '4px 12px',
  background: '#dbeafe',
  borderRadius: '12px',
  fontSize: '13px',
  fontWeight: '600',
  color: '#1e40af',
};

export const lotCellStyle = (isManual) => ({
  padding: '14px 12px',
  fontSize: '14px',
  color: isManual ? '#374151' : '#2563eb',
  cursor: isManual ? 'default' : 'pointer',
});

export const lotInputStyle = {
  width: '100%',
  padding: '8px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
};

export const lotDisplayStyle = (hasLot) => ({
  display: 'inline-block',
  padding: hasLot ? '6px 12px' : '6px',
  background: hasLot ? '#e0e7ff' : 'transparent',
  borderRadius: '6px',
  fontSize: '13px',
  color: hasLot ? '#3730a3' : '#9ca3af',
  fontStyle: hasLot ? 'normal' : 'italic',
});

export const deleteButton = {
  padding: '6px 12px',
  background: '#fee2e2',
  color: '#dc2626',
  border: '1px solid #fecaca',
  borderRadius: '6px',
  fontSize: '13px',
  fontWeight: '500',
  cursor: 'pointer',
};

export const emptyState = {
  textAlign: 'center',
  padding: '60px 20px',
  color: '#9ca3af',
};

export const emptyStateSubtext = {
  fontSize: '14px',
  margin: '8px 0 0 0',
};

/* ================= COMPACT BOX TABS STYLES ================= */
export const tabsContainer = {
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  gap: '12px',
  padding: '12px 4px',
  marginBottom: '0',
  scrollbarWidth: 'thin',
  scrollbarColor: '#cbd5e1 transparent',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

export const boxTabContainer = (isActive) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '180px',
  maxWidth: '180px',
  width: '180px',
  flexShrink: 0,
  background: isActive ? '#f0f9ff' : 'white',
  borderRadius: '8px',
  border: isActive ? '2px solid #3b82f6' : '1px solid #e2e8f0',
  padding: '14px',
  position: 'relative',
  boxShadow: isActive ? '0 2px 8px rgba(59, 130, 246, 0.15)' : '0 1px 2px rgba(0,0,0,0.05)',
  transition: 'all 0.2s ease',
  boxSizing: 'border-box',
});

/* Box Header with Border Label */
export const boxHeader = (isActive) => ({
  position: 'relative',
  marginBottom: '14px',
  paddingBottom: '8px',
  borderBottom: `2px solid ${isActive ? '#3b82f6' : '#e5e7eb'}`,
});

export const boxTitle = (isActive) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: isActive ? '#1e40af' : '#374151',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '6px',
  width: '100%',
});

export const boxNumberBadge = (isActive) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  background: isActive ? '#3b82f6' : '#f1f5f9',
  color: isActive ? 'white' : '#64748b',
  fontWeight: 'bold',
  fontSize: '12px',
  border: isActive ? '2px solid #1d4ed8' : '1px solid #e2e8f0',
  flexShrink: 0,
});

export const itemCountBadge = {
  fontSize: '11px',
  fontWeight: '600',
  color: '#6b7280',
  backgroundColor: '#f3f4f6',
  padding: '2px 6px',
  borderRadius: '8px',
  flexShrink: 0,
};

/* Vertical Dimensions Layout */
export const verticalDimensionsContainer = (isActive) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
});

export const dimensionRow = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const dimensionLabelCompact = {
  fontSize: '11px',
  fontWeight: '600',
  color: '#4b5563',
  textTransform: 'uppercase',
  letterSpacing: '0.3px',
  flexShrink: 0,
};

export const dimensionInputCompact = (isActive) => ({
  flex: 1,
  padding: '6px',
  border: isActive ? '1px solid #93c5fd' : '1px solid #d1d5db',
  borderRadius: '4px',
  fontSize: '12px',
  textAlign: 'center',
  backgroundColor: isActive ? '#f8fafc' : 'white',
  color: isActive ? '#1e40af' : '#374151',
  fontWeight: '500',
  minWidth: '0',
});

export const dimensionUnit = {
  fontSize: '10px',
  color: '#6b7280',
  minWidth: '25px',
  fontWeight: '500',
  flexShrink: 0,
};

export const activeBoxIndicator = {
  position: 'absolute',
  top: '-6px',
  left: '-6px',
  backgroundColor: '#3b82f6',
  color: 'white',
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '9px',
  fontWeight: 'bold',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  zIndex: 10,
};

export const scanButton = (isActive) => ({
  padding: '6px 10px',
  backgroundColor: isActive ? '#3b82f6' : '#f1f5f9',
  color: isActive ? 'white' : '#64748b',
  border: 'none',
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: '600',
  cursor: 'pointer',
  width: '100%',
  transition: 'all 0.2s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
});

/* Update cardHeader to be more compact */
export const cardHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
  flexWrap: 'wrap',
  gap: '12px',
};

/* ================= SCAN STATUS STYLES ================= */
export const scanStatusContainer = {
  backgroundColor: '#f8fafc',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  padding: '16px',
};

export const scanStatus = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '8px',
};

export const scanStatusLabel = {
  fontWeight: '600',
  color: '#475569',
};

export const scanModeActive = {
  padding: '6px 12px',
  backgroundColor: '#3b82f6',
  color: 'white',
  borderRadius: '6px',
  fontWeight: 'bold',
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
};

export const scanModeInactive = {
  padding: '6px 12px',
  backgroundColor: '#f1f5f9',
  color: '#64748b',
  borderRadius: '6px',
  fontWeight: '500',
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
};

export const scanInfo = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  fontSize: '14px',
  color: '#475569',
};

export const scanInfoText = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const trStyle = (isActive) => ({
  backgroundColor: isActive ? '#f0f9ff' : 'white',
  borderLeft: isActive ? '4px solid #3b82f6' : 'none',
  transition: 'background-color 0.2s',
});

/* ================= CUSTOM SCROLLBAR STYLES ================= */
export const customScrollbar = {
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f5f9',
    borderRadius: '4px',
    margin: '0 16px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#cbd5e1',
    borderRadius: '4px',
    border: '2px solid #f1f5f9',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#94a3b8',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: '#cbd5e1 #f1f5f9',
};

// Add these styles to your existing PackagingSlip.styles
// export const formGrid = {
//   display: 'grid',
//   gridTemplateColumns: '1fr 1fr',
//   gap: '20px',
//   marginBottom: '20px',
// };

export const formGroup = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

// export const labelStyle = {
//   fontSize: '14px',
//   fontWeight: '600',
//   color: '#374151',
//   marginBottom: '4px',
// };

// export const inputStyle = {
//   padding: '10px 12px',
//   border: '1px solid #d1d5db',
//   borderRadius: '6px',
//   fontSize: '14px',
//   color: '#374151',
//   backgroundColor: 'white',
//   outline: 'none',
//   transition: 'border-color 0.2s',
//   ':focus': {
//     borderColor: '#3b82f6',
//     boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
//   },
// };